import React, { memo } from 'react';
import HBDropdown, { IDropdown } from '../HBDropdown/HBDropdown';
import { TOptionValue } from '../HBDropdown/HBDropdown.types';
import HBDropdownField, {
    HBDropdownFieldProps
} from '../HBDropdownField/HBDropdownField';
import useFormFieldProps, {
    FormFieldProps,
    useFormInputProps,
    useFormInputValidationProps
} from './useFormFieldProps';

const HBFormDropdownField = <Value extends TOptionValue>(
    props: FormFieldProps<HBDropdownFieldProps<Value>>
) => {
    const fieldProps = useFormFieldProps(props);
    const validationProps = useFormInputValidationProps(props.id);

    return <HBDropdownField {...fieldProps} {...validationProps} />;
};

const FormDropdown = <Value extends TOptionValue>(
    props: FormFieldProps<IDropdown<Value>>
) => {
    const inputProps = useFormInputProps(props);

    return <HBDropdown {...inputProps} />;
};

const memoized = memo(FormDropdown) as typeof FormDropdown;

export { memoized as FormDropdown };

export default memo(HBFormDropdownField) as typeof HBFormDropdownField;
